import { render, staticRenderFns } from "./InputSwitch.vue?vue&type=template&id=ed1f5654&scoped=true"
import script from "./InputSwitch.vue?vue&type=script&lang=js"
export * from "./InputSwitch.vue?vue&type=script&lang=js"
import style0 from "./InputSwitch.vue?vue&type=style&index=0&id=ed1f5654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1f5654",
  null
  
)

export default component.exports